import React, { FC, useContext, useEffect, useRef } from 'react'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import CloseIcon from './close.svg'
import CloseMobileIcon from './close-mobile.svg'
import styles from './ReviewDetail.module.scss'
import Loader from '../../common/Loader/Loader'
import ReviewDetailContent from './ReviewDetailContent'
import cn from 'classnames'
import { ReviewDetailContext } from '../../../contexts/ReviewDetailProvider'

const ReviewDetail: FC = () => {
  const { review, handlerClose, loading } = useContext(ReviewDetailContext)
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (!dialogRef?.current) return

    const scrollPosition = window.scrollY

    disableBodyScroll(dialogRef.current)

    return () => {
      clearAllBodyScrollLocks()
      window.scrollTo(0, scrollPosition)
    }
  }, [dialogRef.current])

  return (
    <dialog
      className={cn(styles.dialog, loading && styles['dialog--loading'])}
      open
      ref={dialogRef}
    >
      <button
        onClick={handlerClose}
        type="button"
        className={styles.closeButton}
      >
        <CloseIcon className={styles['closeIcon--desk']} />
        <CloseMobileIcon className={styles['closeIcon--mobile']} />
      </button>
      {loading ? (
        <Loader className={styles.loader} />
      ) : (
        <ReviewDetailContent review={review} />
      )}
    </dialog>
  )
}

export default ReviewDetail
